import { MarketAPILegalContent, MarketPolicies } from "src/model/shop.model";
import { APP_DEFAULT_SHOP_ID } from "src/utils/constants";

export interface RestrictedAddressCodes {
  statesRestricted: string[] | [];
  zipCodesRestricted: string[] | [];
}

export interface LegalContent extends MarketAPILegalContent {
  termsAndConditionsUrl: string;
  privacyPolicyUrl: string;
  omnibusUrl: string;
  legalText: string;
  policies: MarketPolicies[] | Array<any>;
  dacEnabled?: boolean;
  digitalServicesContact?: string;
}
export interface StoreState {
  storeId: number;
  restrictedAddressCodes: RestrictedAddressCodes;
  legalContent: LegalContent;
}

export const storeInitialState: StoreState = {
  storeId: APP_DEFAULT_SHOP_ID,
  restrictedAddressCodes: { statesRestricted: [], zipCodesRestricted: [] },
  legalContent: {
    termsAndConditionsUrl: "",
    privacyPolicyUrl: "",
    omnibusUrl: "",
    legalText: "",
    feedTitle:"",
		feedDescription:"",
		legalTitle:"",
		legalDescription:"",
    policies:[],
    dacEnabled: true,
    digitalServicesContact: ""
  },
};
